import { api } from '@/shared/api/client'
import { UI_VARIANT_RESOLUTION_TIMEOUT_MS, type UIVariantResolution } from './types'

/** Resolve the calling member's variant. Bounded; never retried. */
export function getUIVariantResolution(signal?: AbortSignal): Promise<UIVariantResolution> {
  return api.get<UIVariantResolution>('governance/ui-variant', undefined, {
    timeout: UI_VARIANT_RESOLUTION_TIMEOUT_MS,
    retry: 0,
    ...(signal ? { signal } : {}),
  })
}
